export const GET_AMLS_COMMON_UNIFIED_ALERTS = 'GET_AMLS_COMMON_UNIFIED_ALERTS';
export const CLEAR_AMLS_COMMON_UNIFIED_ALERTS =
  'CLEAR_AMLS_COMMON_UNIFIED_ALERTS';
export const GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS =
  'GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS';
export const GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL =
  'GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL';

export const GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS =
  'GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS';
export const GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_SUCCESS =
  'GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_SUCCESS';
export const GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_FAIL =
  'GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_FAIL';

export const GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION =
  'GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION';
export const CLEAR_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION =
  'CLEAR_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION';
export const GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS_PREVENTION =
  'GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS_PREVENTION';
export const GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL_PREVENTION =
  'GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL_PREVENTION';

export const GET_AMLS_COMMON_ALERT_DETAILS = 'GET_AMLS_COMMON_ALERT_DETAILS';
export const GET_AMLS_COMMON_ALERT_DETAILS_SUCCESS =
  'GET_AMLS_COMMON_ALERT_DETAILS_SUCCESS';
export const GET_AMLS_COMMON_ALERT_DETAILS_FAIL =
  'GET_AMLS_COMMON_ALERT_DETAILS_FAIL';

export const GET_AMLS_COMMON_ALERT_PARTY_IDENTITY =
  'GET_AMLS_COMMON_ALERT_PARTY_IDENTITY';
export const GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_SUCCESS =
  'GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_SUCCESS';
export const GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_FAIL =
  'GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_FAIL';

export const GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS =
  'GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS';
export const GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_SUCCESS =
  'GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_SUCCESS';
export const GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_FAIL =
  'GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_FAIL';

export const GET_AMLS_COMMON_TICKETS = 'GET_AMLS_COMMON_TICKETS';
export const GET_AMLS_COMMON_TICKETS_SUCCESS =
  'GET_AMLS_COMMON_TICKETS_SUCCESS';
export const GET_AMLS_COMMON_TICKETS_FAIL = 'GET_AMLS_COMMON_TICKETS_FAIL';

export const PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET =
  'PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET';
export const PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_SUCCESS =
  'PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_SUCCESS';
export const PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_FAIL =
  'PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_FAIL';
export const RESET_AMLS_COMMON_APPROVE_AND_REJECT_TICKET =
  'RESET_AMLS_COMMON_APPROVE_AND_REJECT_TICKET';
export const PUT_AMLS_COMMON_ALERT_PARTY_UPDATE =
  'PUT_AMLS_COMMON_ALERT_PARTY_UPDATE';
export const PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_SUCCESS =
  'PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_SUCCESS';
export const PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_FAIL =
  'PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_FAIL';

export const GET_AMLS_COMMON_SANDBOX_UI = 'GET_AMLS_COMMON_SANDBOX_UI';
export const GET_AMLS_COMMON_SANDBOX_UI_SUCCESS =
  'GET_AMLS_COMMON_SANDBOX_UI_SUCCESS';
export const GET_AMLS_COMMON_SANDBOX_UI_FAIL =
  'GET_AMLS_COMMON_SANDBOX_UI_FAIL';
export const RESET_AMLS_COMMON_SANDBOX_UI_RESULTS =
  'RESET_AMLS_COMMON_SANDBOX_UI_RESULTS';
export const GET_AMLS_COMMON_KYC_ALERTS = 'GET_AMLS_COMMON_KYC_ALERTS';
export const GET_AMLS_COMMON_KYC_ALERTS_SUCCESS =
  'GET_AMLS_COMMON_KYC_ALERTS_SUCCESS';
export const GET_AMLS_COMMON_KYC_ALERTS_FAIL =
  'GET_AMLS_COMMON_KYC_ALERTS_FAIL';
export const GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD =
  'GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD';
export const GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_SUCCESS =
  'GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_SUCCESS';
export const GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_FAIL =
  'GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_FAIL';

export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES';
export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_SUCCESS =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_SUCCESS';
export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_FAIL =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_FAIL';

export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES';
export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES_SUCCESS =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES_SUCCESS';
export const GET_AMLS_COMMON_DYNAMIC_PROPERTIES_FAIL =
  'GET_AMLS_COMMON_DYNAMIC_PROPERTIES_FAIL';
export const RESET_AMLS_COMMON_DYNAMIC_PROPERTIES =
  'RESET_AMLS_COMMON_DYNAMIC_PROPERTIES';

export const PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE =
  'PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE';
export const PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_SUCCESS =
  'PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_SUCCESS';
export const PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_FAIL =
  'PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_FAIL';
export const PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_RESET =
  'PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_RESET';

export const GET_AMLS_COMMON_PIPELINES = 'GET_AMLS_COMMON_PIPELINES';
export const GET_AMLS_COMMON_PIPELINES_SUCCESS =
  'GET_AMLS_COMMON_PIPELINES_SUCCESS';
export const GET_AMLS_COMMON_PIPELINES_FAIL = 'GET_AMLS_COMMON_PIPELINES_FAIL';

export const POST_AMLS_COMMON_PIPELINES_RUN = 'POST_AMLS_COMMON_PIPELINES_RUN';
export const POST_AMLS_COMMON_PIPELINES_RUN_SUCCESS =
  'POST_AMLS_COMMON_PIPELINES_RUN_SUCCESS';
export const POST_AMLS_COMMON_PIPELINES_RUN_FAIL =
  'POST_AMLS_COMMON_PIPELINES_RUN_FAIL';

export const POST_AMLS_COMMON_PIPELINES_SCHEDULE =
  'POST_AMLS_COMMON_PIPELINES_SCHEDULE';
export const POST_AMLS_COMMON_PIPELINES_SCHEDULE_SUCCESS =
  'POST_AMLS_COMMON_PIPELINES_SCHEDULE_SUCCESS';
export const POST_AMLS_COMMON_PIPELINES_SCHEDULE_FAIL =
  'POST_AMLS_COMMON_PIPELINES_SCHEDULE_FAIL';

export const POST_AMLS_COMMON_PIPELINES_UNSCHEDULE =
  'POST_AMLS_COMMON_PIPELINES_UNSCHEDULE';
export const POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_SUCCESS =
  'POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_SUCCESS';
export const POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_FAIL =
  'POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_FAIL';

export const GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO =
  'GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO';
export const GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_SUCCESS =
  'GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_SUCCESS';
export const GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_FAIL =
  'GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_FAIL';

export const GET_AMLS_COMMON_PIPELINES_HISTORY =
  'GET_AMLS_COMMON_PIPELINES_HISTORY';
export const GET_AMLS_COMMON_PIPELINES_HISTORY_SUCCESS =
  'GET_AMLS_COMMON_PIPELINES_HISTORY_SUCCESS';
export const GET_AMLS_COMMON_PIPELINES_HISTORY_FAIL =
  'GET_AMLS_COMMON_PIPELINES_HISTORY_FAIL';

export const POST_AMLS_COMMON_PIPELINE_STOP = 'POST_AMLS_COMMON_PIPELINE_STOP';
export const POST_AMLS_COMMON_PIPELINE_STOP_SUCCESS =
  'POST_AMLS_COMMON_PIPELINE_STOP_SUCCESS';
export const POST_AMLS_COMMON_PIPELINE_STOP_FAIL =
  'POST_AMLS_COMMON_PIPELINE_STOP_FAIL';
export const FETCH_TRM_ACTIONS_OF_TYPOLOGIES =
  'FETCH_TRM_ACTIONS_OF_TYPOLOGIES';
export const FETCH_TRM_ACTIONS_OF_TYPOLOGIES_SUCCESS =
  'FETCH_TRM_ACTIONS_OF_TYPOLOGIES_SUCCESS';
export const FETCH_TRM_ACTIONS_OF_TYPOLOGIES_FAIL =
  'FETCH_TRM_ACTIONS_OF_TYPOLOGIES_FAIL';

export const GET_AMLS_COMMON_NOTIFICATIONS = 'GET_AMLS_COMMON_NOTIFICATIONS';
export const GET_AMLS_COMMON_NOTIFICATIONS_SUCCESS =
  'GET_AMLS_COMMON_NOTIFICATIONS_SUCCESS';
export const GET_AMLS_COMMON_NOTIFICATIONS_FAIL =
  'GET_AMLS_COMMON_NOTIFICATIONS_FAIL';

export const FETCH_AMLS_ALERT_LEVEL = 'FETCH_AMLS_ALERT_LEVEL';
export const FETCH_AMLS_ALERT_LEVELS_SUCCESS =
  'FETCH_AMLS_ALERT_LEVELS_SUCCESS';
export const FETCH_AMLS_ALERT_LEVELS_FAIL = 'FETCH_AMLS_ALERT_LEVELS_FAIL';

export function fetchTypologiesActions(payload) {
  return {
    type: FETCH_TRM_ACTIONS_OF_TYPOLOGIES,
    payload
  };
}

export function fetchTypologiesActionsSuccess(payload) {
  return {
    type: FETCH_TRM_ACTIONS_OF_TYPOLOGIES_SUCCESS,
    payload
  };
}

export function fetchTypologiesActionsFail(payload) {
  return {
    type: FETCH_TRM_ACTIONS_OF_TYPOLOGIES_FAIL,
    payload
  };
}

export function getAMLSCommonUnifiedAlerts(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS,
    payload
  };
}

export function clearAMLSCommonUnifiedAlerts() {
  return {
    type: CLEAR_AMLS_COMMON_UNIFIED_ALERTS
  };
}

export function getAMLSCommonUnifiedAlertsSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS,
    payload
  };
}

export function getAMLSCommonUnifiedAlertsFail(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL,
    payload
  };
}

export function getAMLSCommonUnifiedAlertCounts(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS,
    payload
  };
}

export function getAMLSCommonUnifiedAlertCountsSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_SUCCESS,
    payload
  };
}

export function getAMLSCommonUnifiedAlertCountsFail(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_FAIL,
    payload
  };
}

export function getAMLSCommonUnifiedAlertsPrevention(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION,
    payload
  };
}

export function clearAMLSCommonUnifiedAlertsPrevention() {
  return {
    type: CLEAR_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION
  };
}

export function getAMLSCommonUnifiedAlertsPreventionSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS_SUCCESS_PREVENTION,
    payload
  };
}

export function getAMLSCommonUnifiedAlertsPreventionFail(payload) {
  return {
    type: GET_AMLS_COMMON_UNIFIED_ALERTS_FAIL_PREVENTION,
    payload
  };
}

export function getCommonKYCcustomers(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS,
    payload
  };
}

export function getCommonKYCcustomersSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS_SUCCESS,
    payload
  };
}

export function getCommonKYCcustomersFail(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS_FAIL,
    payload
  };
}

export function getCommonKYCcustomersDownload(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD,
    payload
  };
}

export function getCommonKYCcustomersDownloadSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_SUCCESS,
    payload
  };
}

export function getCommonKYCcustomersDownloadFail(payload) {
  return {
    type: GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD_FAIL,
    payload
  };
}

export function getAMLSCommonAlertDetails(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_DETAILS,
    payload
  };
}

export function getAMLSCommonAlertDetailsSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_DETAILS_SUCCESS,
    payload
  };
}

export function getAMLSCommonAlertDetailsFail(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_DETAILS_FAIL,
    payload
  };
}

export function getAMLSCommonAlertPartyIdentity(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_PARTY_IDENTITY,
    payload
  };
}

export function getAMLSCommonAlertPartyIdentitySuccess(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_SUCCESS,
    payload
  };
}

export function getAMLSCommonAlertPartyIdentityFail(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_PARTY_IDENTITY_FAIL,
    payload
  };
}

export function getAMLSCommonAlertAssocCustomers(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS,
    payload
  };
}

export function getAMLSCommonAlertAssocCustomersSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_SUCCESS,
    payload
  };
}

export function getAMLSCommonAlertAssocCustomersFail(payload) {
  return {
    type: GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS_FAIL,
    payload
  };
}

export function getAMLSCommonTickets(payload) {
  return {
    type: GET_AMLS_COMMON_TICKETS,
    payload
  };
}
export function putAMLSCommonAlertPartyUpdate(payload) {
  return {
    type: PUT_AMLS_COMMON_ALERT_PARTY_UPDATE,
    payload
  };
}

export function getAMLSCommonTicketsSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_TICKETS_SUCCESS,
    payload
  };
}
export function putAMLSCommonAlertPartyUpdateSuccess(payload) {
  return {
    type: PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_SUCCESS,
    payload
  };
}

export function getAMLSCommonTicketsFail(payload) {
  return {
    type: GET_AMLS_COMMON_TICKETS_FAIL,
    payload
  };
}

export function putAMLSCommonApproveAndRejectTicket(payload) {
  return {
    type: PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
    payload
  };
}

export function putAMLSCommonApproveAndRejectTicketSuccess(payload) {
  return {
    type: PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_SUCCESS,
    payload
  };
}

export function putAMLSCommonApproveAndRejectTicketFail(payload) {
  return {
    type: PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET_FAIL,
    payload
  };
}

export function resetAMLSCommonApproveAndRejectTicket(payload) {
  return {
    type: RESET_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
    payload
  };
}

export function putAMLSCommonAlertPartyUpdateFail(payload) {
  return {
    type: PUT_AMLS_COMMON_ALERT_PARTY_UPDATE_FAIL,
    payload
  };
}

export function getAMLSCommonSandboxUI(payload) {
  return {
    type: GET_AMLS_COMMON_SANDBOX_UI,
    payload
  };
}

export function getAMLSCommonSandboxUISuccess(payload) {
  return {
    type: GET_AMLS_COMMON_SANDBOX_UI_SUCCESS,
    payload
  };
}

export function getAMLSCommonSandboxUIFail(payload) {
  return {
    type: GET_AMLS_COMMON_SANDBOX_UI_FAIL,
    payload
  };
}

export function resetAMLSCommonSandboxUIResults() {
  return {
    type: RESET_AMLS_COMMON_SANDBOX_UI_RESULTS
  };
}

export function getAMLSCommonDynamicPropertiesCategories(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES,
    payload
  };
}

export function getAMLSCommonDynamicPropertiesCategoriesSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_SUCCESS,
    payload
  };
}

export function getAMLSCommonDynamicPropertiesCategoriesFail(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES_FAIL,
    payload
  };
}

export function getAMLSCommonDynamicProperties(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES,
    payload
  };
}

export function getAMLSCommonDynamicPropertiesSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES_SUCCESS,
    payload
  };
}

export function getAMLSCommonDynamicPropertiesFail(payload) {
  return {
    type: GET_AMLS_COMMON_DYNAMIC_PROPERTIES_FAIL,
    payload
  };
}

export function resetAMLSCommonDynamicProperties() {
  return {
    type: RESET_AMLS_COMMON_DYNAMIC_PROPERTIES
  };
}

export function putAMLSCommonDynamicPropertiesUpdate(
  payload,
  getDynamicPropertiesPayload
) {
  return {
    type: PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE,
    payload,
    getDynamicPropertiesPayload
  };
}

export function putAMLSCommonDynamicPropertiesUpdateSuccess(payload) {
  return {
    type: PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_SUCCESS,
    payload
  };
}

export function putAMLSCommonDynamicPropertiesUpdateFail(payload) {
  return {
    type: PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_FAIL,
    payload
  };
}

export function putAMLSCommonDynamicPropertiesUpdateReset() {
  return {
    type: PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE_RESET
  };
}

export function getAMLSCommonPipelines(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES,
    payload
  };
}

export function getAMLSCommonPipelinesSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_SUCCESS,
    payload
  };
}

export function getAMLSCommonPipelinesFail(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_FAIL,
    payload
  };
}

export function postAMLSCommonPipelinesRun(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_RUN,
    payload
  };
}

export function postAMLSCommonPipelinesRunSuccess(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_RUN_SUCCESS,
    payload
  };
}

export function postAMLSCommonPipelinesRunFail(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_RUN_FAIL,
    payload
  };
}

export function postAMLSCommonPipelinesSchedule(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_SCHEDULE,
    payload
  };
}

export function postAMLSCommonPipelinesScheduleSuccess(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_SCHEDULE_SUCCESS,
    payload
  };
}

export function postAMLSCommonPipelinesScheduleFail(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_SCHEDULE_FAIL,
    payload
  };
}

export function postAMLSCommonPipelinesUnSchedule(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_UNSCHEDULE,
    payload
  };
}

export function postAMLSCommonPipelinesUnScheduleSuccess(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_SUCCESS,
    payload
  };
}

export function postAMLSCommonPipelinesUnScheduleFail(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINES_UNSCHEDULE_FAIL,
    payload
  };
}

export function getAMLSCommonPipelinesScheduleInfo(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO,
    payload
  };
}

export function getAMLSCommonPipelinesScheduleInfoSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_SUCCESS,
    payload
  };
}

export function getAMLSCommonPipelinesScheduleInfoFail(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO_FAIL,
    payload
  };
}

export function getAMLSCommonPipelinesHistory(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_HISTORY,
    payload
  };
}

export function getAMLSCommonPipelinesHistorySuccess(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_HISTORY_SUCCESS,
    payload
  };
}

export function getAMLSCommonPipelinesHistoryFail(payload) {
  return {
    type: GET_AMLS_COMMON_PIPELINES_HISTORY_FAIL,
    payload
  };
}

export function postAMLSCommonPipelineStop(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINE_STOP,
    payload
  };
}

export function postAMLSCommonPipelineStopSuccess(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINE_STOP_SUCCESS,
    payload
  };
}

export function postAMLSCommonPipelineStopFail(payload) {
  return {
    type: POST_AMLS_COMMON_PIPELINE_STOP_FAIL,
    payload
  };
}

export function getAMLSCommonNotifications() {
  return {
    type: GET_AMLS_COMMON_NOTIFICATIONS
  };
}

export function getAMLSCommonNotificationsSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_NOTIFICATIONS_SUCCESS,
    payload
  };
}

export function getAMLSCommonNotificationsFail(payload) {
  return {
    type: GET_AMLS_COMMON_NOTIFICATIONS_FAIL,
    payload
  };
}

export const fetchAMLSAlertLevel = () => ({
  type: FETCH_AMLS_ALERT_LEVEL
});

export const fetchAMLSAlertLevelSuccess = (alertLevels) => ({
  type: FETCH_AMLS_ALERT_LEVELS_SUCCESS,
  payload: alertLevels
});

export const fetchAMLSAlertLevelFail = (payload) => ({
  type: FETCH_AMLS_ALERT_LEVELS_FAIL,
  payload
});
